export default __webpack_public_path__ + "static/media/toggleTick.85204a33.svg";